<template>
  <v-dialog v-model="isOpen" persistent max-width="800">
    <v-card class="modal-card">
      <h2 class="text-left full-width mb-4">
        {{ $t("message.facilitiesAddNew.addFacilitySearchingOnTheMap") }}
      </h2>
      <p>
        {{
          $t("message.facilitiesAddNew.addFacilitySearchingOnTheMapDescription")
        }}
      </p>
      <v-row class="full-width align-center">
        <v-col cols="12" md="8">
          <v-autocomplete
            name="mapPlaces"
            ref="input"
            :search-input.sync="autocompleteSearch"
            :label="this.$t('message.wizard.addNameAndchooseFromList')"
            :loading="loading"
            :items="autocompleteSuggestions"
            return-object
            no-filter
            item-text="description"
            v-model="autocompleteSelected"
            autocomplete="off"
          >
            <template #no-data>
              <v-list-item>
                <v-list-item-content style="flex-basis: auto;">
                  <span>
                    {{ $t("message.wizard.addNameAndchooseFromList") }}
                  </span>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template #append-item>
              <div class="d-flex justify-end mr-2">
                <img
                  src="@/static/powered_by_google_on_white.png"
                  alt="powered by Google"
                />
              </div>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-btn
            :disabled="!autocompleteSelected"
            color="primary"
            @click="addBusinessAddressToList"
          >
            {{ $t("message.common.add") }}
          </v-btn>
        </v-col>
        <v-col cols="12">
          <v-btn
            color="primary"
            outlined
            class="mx-2"
            min-width="188"
            @click="$emit('closeDialog', false)"
          >
            {{ $t("message.common.cancel") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import serviceHandler from "@/helpers/handlers/service";
import businessAddressesService from "@/services/businessAddresses";
import companyService from "@/services/company";
import { debounce } from "@/helpers/helpers";
export default {
  name: "NewFacility",
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      autocompleteSuggestions: [],
      autocompleteSelected: null,
      autocompleteSearch: null,
      loading: false
    };
  },
  watch: {
    autocompleteSearch(value) {
      const CHAR_LENGTH = 2;

      if (value && value.length >= CHAR_LENGTH) {
        this.sendSearch(value);
      }
    },
    isOpen(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.$refs.input.focus();
        }, 150);
      }
    }
  },
  methods: {
    async addBusinessAddressToList() {
      this.loading = true;
      if (this.autocompleteSelected) {
        const data = await serviceHandler(
          companyService.getBusinessAddressData(
            this.autocompleteSelected.place_id
          )
        );

        await this.add(data);
        this.autocompleteSelected = null;
        if (this.page !== 1) {
          this.page = 1;
        }
      }
      this.loading = false;
      this.$emit("closeDialog", false);
    },
    async add(businessAddress) {
      const businessAddressCreated = await serviceHandler(
        businessAddressesService.postBusinessAddresses([businessAddress]),
        this.$t(
          "message.companyProfile.listings.confirmationDialog.tooManyRequestsErrorText"
        )
      );

      if (businessAddressCreated) {
        this.$notify({
          group: "default",
          type: "success",
          text: this.$t("message.notification.changesSaved")
        });
      }
    },
    sendSearch: debounce(async function() {
      this.autocompleteSuggestions = await serviceHandler(
        companyService.getAutocompleteList(this.autocompleteSearch)
      );
    }, 500)
  }
};
</script>

<style lang="scss" scoped>
.modal-card {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: $spacing * 3;
}

.modal-title {
  @include font-size(16px);
  font-family: $font-family-base;
  font-weight: $font-weight-bold;
  margin-bottom: $spacing * 2;
  margin-top: $spacing;
}

.modal-content {
  @include font-size(14px);
  width: 100%;
  max-width: 350px;
  margin-bottom: $spacing * 4;
  text-align: center;
}
</style>
